import { NgModule } from '@angular/core';
import { Platform, PlatformModule } from '@angular/cdk/platform';
import { ElPlatform } from './platform-service';

@NgModule({
  providers: [
    { provide: ElPlatform, useExisting: Platform },
  ],
})
export class ElPlatformModule extends PlatformModule {}
